import React, { Component } from 'react';
// rest client
import { eapiClient } from '../../../../restClient';
// style
import './styles.css';

export default class AddUserSearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      showOptions: false,
      showCreateEntity: false,
      selectedOptionValue: '',
      selectedOption: ''
    }
  }

  filterList = (event) => {
    var query = event.target.value;
    this.setState({
      selectedOptionValue: query
    });

    if (query.length > 2) {
      this.setState({ showCreateEntity: true });
      let url = this.props.sow ? '/users/sowUserSearch/' + query + '/Sales Manager' : '/users/search?userId=' + query;
      eapiClient(url, { noBlocking: true })
        .then(({ data }) => {
          if (data.responseStatus.serviceErrorCode !== 404 && Array.isArray(data.responseData)) {
            this.setState({ options: data.responseData, showOptions: true });
          } else {
            this.hideOptions();
          }
        });
    } else {
      this.setState({ showCreateEntity: false }, () => {
        this.hideOptions();
      });
    }
  }

  setSelectedOptions = (event, groupEntity) => {
    this.setState({
      selectedOption: groupEntity
    });
    this.resetSearch();
    this.hideOptions();
    this.props.setSelectedOptions(groupEntity);
  }

  resetSearch = () => {
    this.setState({ selectedOptionValue: '', options: [], showCreateEntity: false });
  }

  showOptions = () => {
    this.setState({ showOptions: true });
  }

  hideOptions = () => {
    this.setState({ showOptions: false });
  }

  render() {

    const options = (
      <List
        role="option"
        tabIndex="0"
        items={this.state.options}
        _setSelectedOptions={(event, entity) => this.setSelectedOptions(event, entity)}
        aria-selected="true"
      />
    );

    return (
      <div className="customersearchcont">
        <div className="admin-filterdata">
          <fieldset className="form-group searchListform">
            <input
              type="text"
              tabIndex="0"
              role={this.props.role}
              maxLength={this.props.maxLength}
              id="searchText"
              onFocus={this.showOptions}
              onChange={this.filterList}
              value={this.state.selectedOptionValue}
              className="form-control form-control-lg"
              disabled={this.props.isDisable}
            />
            <span className="icon icon-search serachicon"></span>
          </fieldset>
        </div>
        <div id="searchId" className="admin-searchList" role="dropdown">
          {this.state.showOptions ? options : ''}
        </div>
      </div>
    );
  }
}

const List = (props) => (
  <div className="listContent" id="setList">
    {
      props.items.map((item, index) => (
        <div className="listdata" key={index}>
          <div className="searchListdata"
            data-category={item.status}
            tabIndex="0"
            onClick={(event) => props._setSelectedOptions(event, item)}
          >
            {item.name}
          </div>
          <div className="divide"></div>
        </div>
      ))
    }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/AddUserSearchBox/index.js